<template>
  <div>
    <b-navbar variant="primary" type="dark" style="z-index: 110; height: 55px" fixed="top" class="shadow">
      
      <!-- Wide -->
      <b-navbar-brand to="/" class="d-none d-lg-block">
        <img src="@/assets/logo_navbar.png" class="d-inline-block mr-2" style="width: 30px; height: 30px" alt="Bigfox Logo"> BIGFOX
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto d-none d-lg-block">
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <em>{{username}}</em>
          </template>
          <b-dropdown-item @click="logout">Uitloggen</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      
      <!-- Narrow -->
      <div style="height: 100%; width: 1.5em; font-size: 200%" v-b-toggle.sidebar-1 class="text-white d-block d-lg-none">
        <span class="mdi mdi-menu"></span>
      </div>
      <b-navbar-nav class="d-block d-lg-none">
        <h3 class="p-0 m-0">{{$store.state.title}} {{$store.state.subTitle}}</h3>
      </b-navbar-nav>

    </b-navbar>

    <b-sidebar id="sidebar-1" shadow width="280px" backdrop backdrop-variant="white">
      <template v-slot:header="{hide}">
        <b-navbar variant="primary" type="dark" style="height: 55px" fixed="top" class="shadow p-0 pl-3">
            <b-navbar-brand>
              <img src="@/assets/logo_navbar.png" class="d-inline-block mr-2" style="width: 30px; height: 30px" alt="Bigfox Logo"> BIGFOX
            </b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="text-white" @click="hide">
              <span class="mdi mdi-close"></span>
            </b-nav-item>
          </b-navbar-nav>

        </b-navbar>

      </template>
      <div style="margin-top: 55px">
        <menu-bar/>
      </div>
    </b-sidebar>
    
    <b-container fluid>
      <b-row>


        <div class="col-lg-2 d-none d-lg-block bg-light menubar">
          <menu-bar></menu-bar>
        </div>


        <main role="main" class="col-12 offset-lg-2 col-lg-10 px-1 px-lg-4">
          <div class="pt-1 pb-2 mb-2 border-bottom">
            <router-view/>
          </div>
          <div class="text-right text-muted font-italic">Bigfox v{{$options.APP_VERSION}}</div>
        </main>


      </b-row>

    </b-container>
  </div>
</template>

<script>

import {A_LOGOUT, G_USERNAME} from '@/lib/constants';
import MenuBar from '@/components/MenuBar';

export default
{
    components: { MenuBar },
    computed:
    {
        username() { return this.$store.getters[G_USERNAME]; }
    },
    methods:
    {
        async logout()
        {
            await this.$store.dispatch(
                A_LOGOUT,
                {
                    apollo: this.$apollo.getClient(),
                    router: this.$router
                }
            );
        }
    },
    APP_VERSION // Magic constant, see vue.config.js
}
</script>

<style>
</style>